import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-begin',
  templateUrl: './begin.component.html',
  styles: [`
  .underline {
    color: white;
  }`],
  styleUrls: ['./begin.component.css']
})
export class BeginComponent {

    switch: boolean = false;
    counter: number = 0;
    events: string[] = [];

  constructor() { }

  onClickButton() {
      this.switch = !this.switch;
      this.counter++;
      this.events.push(`${this.counter}° click event - ${new Date()}`);
  }

  biggerThanFour(clickEvent: string): boolean {
      let myNumber: number = parseInt(clickEvent.slice(0, clickEvent.indexOf("°")));
      return myNumber > 4;
  }
}